import { useEnvironment } from '@wix/yoshi-flow-editor';
import { useStyles } from '@wix/tpa-settings/react';
import { getIsPostPageBundle } from '@wix/communities-blog-client-common';
import stylesParams from '@app/components/Post/stylesParams';
import { useSelector } from '../components/runtime-context';
import {
  getIsBlogMenuCategoryLabelsEnabled,
  getIsBlogMenuEnabled,
  getIsBlogMenuSearchEnabled,
} from '../selectors/app-settings-selectors';

type BlogMenuSettings = {
  showBlogMenu: boolean;
  showCategoryLabels: boolean;
  showSearch: boolean;
};

const useBlogMenuSettings = (): BlogMenuSettings => {
  const styles = useStyles();
  const { isEditorX: isStudio } = useEnvironment();

  const isPostPage = useSelector(getIsPostPageBundle);
  const showBlogMenuFromStyle = isStudio
    ? styles.get(stylesParams.showMenuCategoryLabels)
    : styles.get(stylesParams.showMenu);
  const showBlogMenuFromStore = useSelector(getIsBlogMenuEnabled);
  const showBlogMenu = isPostPage ? showBlogMenuFromStyle : showBlogMenuFromStore;

  const showCategoryLabelsFromStyle = styles.get(stylesParams.showMenuCategoryLabels);
  const showCategoryLabelsFromStore = useSelector(getIsBlogMenuCategoryLabelsEnabled);
  const showCategoryLabels = isPostPage ? showCategoryLabelsFromStyle : showCategoryLabelsFromStore;

  const showSearchFromStyle = styles.get(stylesParams.showMenuSearch);
  const showSearchFromStore = useSelector(getIsBlogMenuSearchEnabled);
  const showSearch = isPostPage ? showSearchFromStyle : showSearchFromStore;

  return {
    showBlogMenu,
    showCategoryLabels,
    showSearch,
  };
};

export default useBlogMenuSettings;
